require('angular-ui-grid/ui-grid');
require('angular-ui-grid/ui-grid.min.css');

var vskoGrid = angular.module('vskoGrid', ['ui.grid']);
vskoGrid.directive('vskoGrid', [function() {

  return {
    restrict: 'E',
    template: require('./vsko-grid.html'),
    scope: {
      grid: '='
    },
  }
}]);
